<template>
  <div>
    <loading v-show="showLoader" />

    <div class="ib-main-section">
      <div class="container">
        <router-link class="ib-back-btn" :to="{ name: 'Policies' }">Back</router-link>
        <div class="row">
          <div class="col-md-6 pl-0">
            <div class="d2c-class-container" style="padding-top: 77px;">
              <!-- Nav tabs -->
              <h2 class="listing-page-title">Policy Detail</h2>
            </div>
          </div>
          <div class="col-md-6 in-page-infographic">
            <img class="img-fluid" alt="icon" :src="require('@/assets/images/claim-policy-right-img.svg')" />
          </div>
        </div>
      </div>

      <div class="container detail-view-box">
        <div class="row detail-header ib-align-start">
          <div class="col-md-6 col-lg-4 col-xl-3">
            <div class="detail-header-img">
              <div>
                <img class="img-fluid" :src="policy_detail.product.product_image" v-if="policy_detail.product.plan_name == ''" />
                <img class="img-fluid" :src="policy_detail.product.plan_image" v-if="policy_detail.product.plan_name != ''" />
              </div>
              <div class="header-circle-img">
                <img class="img-fluid" :src="policy_detail.company.logo">
              </div>
            </div>
          </div>
          <div class="col-md-6 col-lg-6 col-xl-6 pl-lg-0 pl-lg-0">
            <h3 class="header-title">{{ policy_detail.product.product_name }}
            <small>{{ policy_detail.insurance_sub_type }}</small>
            <small class="ib-card-plan font-10" v-if="policy_detail.product.plan_name != ''">{{ policy_detail.product.plan_name }}</small>
            </h3>
            <div class="" v-if="policy_detail.policy_no != null">
              <p class="header-td-first">Policy No: <span>{{ policy_detail.policy_no }}</span></p>
            </div>
            <div class="" v-else>
              <p class="header-td-first">Order No: <span>{{ policy_detail.tcn_no }}</span></p>
            </div>
            <div class="" v-if="policy_detail.status.toLowerCase() != 'expirig_soon' && policy_detail.status.toLowerCase() != 'expired'">
              <p class="header-td-first" v-if="policy_detail.status == 'issued'">Policy Date: <span>{{ formatDate(policy_detail.coverage_initiate_at) }}</span></p>
              <p class="header-td-first" v-else>Order Date: <span>{{ formatDate(policy_detail.created_at) }}</span></p>
            </div>
            <div class="" v-if="policy_detail.status.toLowerCase() == 'expirig_soon'">
              <p class="header-td-first">Expiring In: <span>{{ calculateExpiry(policy_detail.created_at) }} Days</span></p>
              <p class="header-td-first">Expiring On: <span>{{ formatDate(policy_detail.created_at) }}</span></p>
            </div>
            <div class="" v-if="policy_detail.status.toLowerCase() == 'expired'">
              <p class="header-td-first">Expiry Date: <span>{{ formatDate(policy_detail.created_at) }}</span></p>
            </div>
            <div class="">
              <p class="header-td-first">{{ Insured }} Amount: <span>{{ policy_detail.sum_insured_currency }} </span><span style="color: #3d9cbd !important;">{{ priceFormatter(policy_detail.sum_insured) }}</span></p>
            </div>
          </div>
          <div class="col-lg-3">
            <div :class="policy_detail.consumer_status +'-status' " class="text-capitalize mb-3 ib-status" >{{ policy_detail.consumer_status.replace(/_/g,' ') }}</div>
            <div v-if="policy_detail.promo_code != ''">
              <p class="header-td-first">{{NetPremium}}:</p>
              <div class="header-price">{{ policy_detail.currency }}
                <span class="">{{ priceFormatter(policy_detail.price_before_discount) }}</span>
                <div class="in-text-linethrough">
                  {{policy_detail.currency}}&nbsp;{{ priceFormatter(policy_detail.paid_amount) }}
                </div>
                <div class="in-promobox-gear2">
                  <img class="img-fluid in-promo-gear2" :src="require('@/assets/images/applied-promo-gear.svg')" alt="icon">
                  <div>Applied Promo: <span>{{policy_detail.promo_code}}</span></div>
                </div>
              </div>
              <button class="ib-btn-primary in-renew-btn" v-if="(policy_detail.status.toLowerCase() == 'expiring_soon' || policy_detail.status.toLowerCase() == 'expired') && policy_detail.can_renew_policy == 1" @click="renewPolicy(policy_detail)">Renew Now!</button>
            </div>
            <div v-else>
              <p class="header-td-first">{{ NetPremium }}:</p>
              <h3 class="header-price">{{ policy_detail.currency }}<span>&nbsp;{{ priceFormatter(policy_detail.paid_amount) }}</span></h3>
              <button class="ib-btn-primary in-renew-btn" v-if="(policy_detail.status.toLowerCase() == 'expiring_soon' || policy_detail.status.toLowerCase() == 'expired') && policy_detail.can_renew_policy == 1" @click="renewPolicy(policy_detail)">Renew Now!</button>
            </div>
            <div>
               <!-- in-proceed-btn -->
              <button class="ib-btn-primary" v-if="PaidInstallments != allInstallments" @click="payNow('proceed_to_payment')">Proceed To Payment</button>
              <button class="ib-btn-primary in-proceed-btn" v-else-if="PaidInstallments == allInstallments && policy_detail.long_term_renewable_policy == true" @click="payNow('renew')">Renew</button>
            </div>
          </div>
        </div>
        <div class="row ib-default-flex my-3 in-listing-tabs" style="margin-top: 1.5rem !important;">
          <ul class="nav nav-tabs jbl-nav-tabs" id="myTab" role="tablist">
            <li class="nav-item">
              <a class="nav-link" id="contact-tab" data-toggle="tab" href="#contact" role="tab" aria-controls="contact" aria-selected="false">
                <div>Policy Detail</div>
              </a>
            </li>
<!--            <li class="nav-item" v-if="Object.keys(policy_detail).length > 0 && policy_detail.consumer_status.toLowerCase() == 'expired'">-->
<!--              <a class="nav-link active" id="product-tab" data-toggle="tab" href="#product" role="tab" aria-controls="product" aria-selected="true">-->
<!--                <div>Product Detail</div>-->
<!--              </a>-->
<!--            </li>-->
            <li class="nav-item" >
              <a class="nav-link" :class="Object.keys(policy_detail).length > 0 && policy_detail.consumer_status.toLowerCase() == 'expired' ? '' : 'active'" id="home-tab" data-toggle="tab" href="#home" role="tab" aria-controls="home" aria-selected="true">
                <div>Other Detail</div>
              </a>
            </li>
            <li class="nav-item" v-if="policy_detail.provide_information_through != 'single'">
              <a class="nav-link" id="risk-tab" data-toggle="tab" href="#risk-detail" role="tab" aria-controls="risk-detail" aria-selected="true">
                <div>Risk Detail</div>
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" id="insights-tab" data-toggle="tab" href="#insights" role="tab" aria-controls="insights" aria-selected="true">
                <div>Policy Insights</div>
              </a>
            </li>
            <li class="nav-item" v-if="family_area">
              <a class="nav-link" id="family-tab" data-toggle="tab" href="#family" role="tab" aria-controls="family" aria-selected="false">
                <div>Family Detail</div>
              </a>
            </li>
            <li class="nav-item" v-if="beneficiaries_area">
              <a class="nav-link" id="profile-tab" data-toggle="tab" href="#profile" role="tab" aria-controls="profile" aria-selected="false">
                <div>Beneficiary Detail</div>
              </a>
            </li>
          </ul>
        </div>
        <div class="row row-tab-content" id="myTabContent">
          <!--Policy Detail-->
          <div class="col-md-12 tab-pane fade" id="contact" role="tabpanel" aria-labelledby="contact-tab">
            <div v-if="policy_detail.provide_information_through == 'single'">
              <div class="row px-3">
                <h2 class="claim-sub-heading">Quotation Detail</h2>
                <table class="table table-borderless" >
                  <tr v-for="(data, index) in stage_1" :key="index">
                    <td v-for="(item, key) in data" :key="key">
                      <p class="claim-row-data claim-row-sub-heading">{{ item.label }}</p>
                      <dd class="claim-row-data" v-if="item.label.toLowerCase().includes('dob') || item.label.toLowerCase().includes('date') || item.label.toLowerCase().includes('date')">{{ formatDynamicDate(item.value)}}</dd>
                      <dd class="claim-row-data" v-else>
                        <span v-if="item.label == 'Vehicle Value'">
                          {{priceFormatter(item.value)}}
                        </span>
                        <span v-else>
                        {{ item.value}}
                        </span>
                      </dd>
                    </td>
                  </tr>
                </table>
              </div>
              <div class="row px-3" v-if="risk_detail.documents.length > 0"><h2 class="claim-sub-heading">Documents</h2></div>
              <div class="row px-3" v-for="document in risk_detail.documents">
                <div class="col-md-12">
                  <div class="row">
                    <h4 class="documents-heading" style="text-align:left !important;">{{ document.text.replace(/_/g,' ')}}</h4>
                  </div>
                  <div class="row in-document-flex">
                    <div class="claim-doc-icon" v-for="(key, index) in document.urls">
                      <a :href="key.url" target="_blank">
                        <div class="claim-data-icon">
                          <img class="img-fluid" :src="key.url">
                          <p>Document {{ index+1 }}</p>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row px-3" v-for="document in policy_detail.documents">
                <div class="col-md-12">
                  <div class="row">
                    <h4 class="documents-heading" style="text-align:left !important;">{{ document.text.replace(/_/g,' ')}}</h4>
                  </div>
                  <div class="row in-document-flex">
                    <div class="claim-doc-icon" v-for="(key, index) in document.urls">
                      <a :href="key.url" target="_blank">
                        <div class="claim-data-icon">
                          <img class="img-fluid" :src="key.url">
                          <p>Document {{ index+1 }}</p>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row px-3" v-if="risk_detail.inspection_images.length > 0"><h2 class="claim-sub-heading">Self Inspection Images</h2></div>
              <div class="row px-3" v-for="section in risk_detail.inspection_images" v-if="risk_detail.inspection_images.length > 0">
                <div class="col-md-12">
                  <div class="row">
                    <h4 class="documents-heading">{{ section.text.replace(/_/g,' ')}}</h4>
                  </div>
                  <div class="row mb-3 mx-auto mx-md-0">
                    <div class="col-md-2 claim-car-icon" v-for="(key, index) in section.urls">
                      <a :href="key.url" target="_blank">
                        <!-- class="claim-car-icon" -->
                        <div>
                          <img v-if="key.file_type == 'image'" class="img-fluid" :src="key.url">
                          <video width="320" height="240" v-else controls>
                            <source :src="key.url">
                          </video>

                        </div>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div  v-else>
              <h2 class="claim-sub-heading">Quotation Detail</h2>
              <div class="row px-3">
                  <table class="table table-borderless"  >
                    <tr>
                      <td>
                        <p class="claim-row-data claim-row-sub-heading">Product</p>
                        <dd class="claim-row-data">{{ policy_detail.policy_name }}</dd>
                      </td>
                    </tr>
                  </table>
              </div>
            </div>
          </div>

          <!--Insured Detail-->
          <div class="col-md-12 tab-pane fade" v-if="policy_detail.provide_information_through != 'single'" id="risk-detail" role="tabpanel" aria-labelledby="risk-tab">

              <div class="col-md-12 d-none d-md-block" >
                <div class="row mb-4">
                  <div class="col-12 ib-border-b in-lg-pb--fix">
                    <!-- <div class="d-flex in-risk-title-dropdown">
                      <div class="mb-3 mb-md-0"><h1 class="ib-claim-listing text-capitalize in-title-risk-mb--fix">Risk Listing</h1></div>
                      <div>
                        <select style="width: 100% !important;" class="floating-select"  @change="onChange($event)">
                          <option value="10">Select Items Per Page</option>
                          <option value="5">5</option>
                          <option value="10">10</option>
                          <option value="20">20</option>
                        </select>
                      </div>
                    </div> -->
                    <ul class="list-inline">
<!--                      <li class="mb-3 mb-md-0"><h1 class="ib-claim-listing">Risk Listing</h1></li>-->
                      <form action="" class="float-md-right ml-md-auto list-position">
                        <li class="list-inline-item">
                          <div class="in-risk-title-dropdown in-risk-title-dropdown--fix">
                            <select style="width: 100% !important;" class="floating-select in-dropdown-per-page" @change="onChange($event)">
                              <option value="5">5</option>
                              <option value="10" selected>10</option>
                              <option value="20">20</option>
                            </select>
                            <span class="highlight"></span>
                            <div class="ib-custom-select"></div>
                          </div>
                        </li>
                        <li class="list-inline-item">
                          <ul class="list-inline">
                            <li class="list-inline-item">
                              <div class="jbl-field in-search-field">
                                <input type="text" id="texto" class="jbl-dynamic-input" placeholder="Search here..." v-on:keyup="filterSearch" v-model="searchKey"/>
                              </div>
                            </li>
                            <li class="list-inline-item">
                              <div class="field jbl-responsive-btn">
                                <span v-on:click="donloadPDF()" class="ib-btn-primary ib-btn-width ib-btn-hover"> PDF </span>
                              </div>
                            </li>
                            <li class="list-inline-item">
                              <div class="field jbl-responsive-btn">
                                <router-link :to="'#'" disabled="true" class="ib-btn-primary ib-btn-width ib-btn-hover">Add & Edit Other Detail</router-link>
                              </div>
                            </li>
                          </ul>
                        </li>
                      </form>
                    </ul>
                  </div>
                </div>
                <table class="claim-listing">
                  <tbody>
                  <tr v-for="(risk, index) in dispalyItems" :key="index" @click="ViewRisk(risk.id)">
                    <td class="jbl-responsive-td data-img">

                      <div class="in-listing-img">
                        <img class="img-fluid":src="policy_detail.product.product_image" v-if="policy_detail.product.plan_name == ''" />
                        <div class="position-relative-box">
                          <img alt="icon" class="img-fluid small-icon":src="policy_detail.company.logo"/>
                        </div>
                      </div>
                    </td>
                    <td class="jbl-responsive-td">
                      <div class="jbl-flex-td">
                        <div class="jbl-date-td jbl-date-heading">Risk ID</div>
                        <div class="jbl-date-td">{{ risk.id }}</div>
                      </div>
                    </td>
                    <td class="jbl-responsive-td" v-for="field in risk.form_data.stage_1" v-if="field.display == 1">
                      <div class="jbl-flex-td">
                        <div class="jbl-date-td jbl-date-heading">{{ field.label }}</div>
                        <div class="jbl-date-td">{{ field.value }}</div>
                      </div>
                    </td>
                    <td class="jbl-responsive-td" >
                      <div class="jbl-flex-td">
                        <div class="jbl-date-td jbl-date-heading">Policy Date</div>
                        <div class="jbl-date-td">{{ formatDate(risk.created_at) }}</div>
                      </div>
                    </td>
                    <td class="jbl-responsive-td in-w-60">
                      <img class="img-fluid in-w-10" :src="require('@/assets/images/arrow-down-icon.svg')" alt="icon">
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            <PaginationComponent v-if="isShowing" @updatePage="changePage" @updatedData="getName" :customer_self_policies_filterd="customer_self_policies_filterd" :isShowing="isShowing"/>

          </div>

          <div class="col-md-12 tab-pane fade" :class="Object.keys(policy_detail).length > 0 && policy_detail.consumer_status.toLowerCase() == 'expired'  ? '' : 'active show'" id="home" role="tabpanel" aria-labelledby="home-tab">
            <div class="row px-3" v-for="(item, key) in sections" v-if="policy_detail.provide_information_through == 'single'">
              <h2 class="claim-sub-heading text-capitalize">{{ key.replace(/_/g," ") }}</h2>
              <table class="table table-borderless">
                <tr v-for="data in chunkedData(item)" >
                  <td v-for="(items, key) in data">
<!--                    <p class="claim-row-data claim-row-sub-heading" >{{ formatDynamicDate(item.label) }}</p>-->
                    <p class="claim-row-data claim-row-sub-heading">{{ items.label }}</p>
                    <dd class="claim-row-data" v-if="items.label.toLowerCase().includes('dob') || items.label.toLowerCase().includes('date') || items.label.toLowerCase().includes('date')">{{ formatDynamicDate(items.value)}}</dd>
                    <dd class="claim-row-data" v-else>{{ items.value}}</dd>
                  </td>
                </tr>
              </table>
            </div>
            <div class="row px-3" v-else>
              <h2 class="claim-sub-heading text-capitalize">Other Detail</h2>
              <table class="table table-borderless">
                <tr v-for="data in chunkedData(policy_detail.form_data.stage_4)" >
                  <td v-for="(items, key) in data">
<!--                    <p class="claim-row-data claim-row-sub-heading" >{{ formatDynamicDate(item.label) }}</p>-->
                    <p class="claim-row-data claim-row-sub-heading">{{ items.label }}</p>
                    <dd class="claim-row-data" v-if="items.label.toLowerCase().includes('dob') || items.label.toLowerCase().includes('date') || items.label.toLowerCase().includes('date')">{{ formatDynamicDate(items.value)}}</dd>
                    <dd class="claim-row-data" v-else>{{ items.value}}</dd>
                  </td>
                </tr>
              </table>
            </div>
          </div>
          <!--Insights Detail-->
          <div class="col-md-12 tab-pane fade" id="insights" role="tabpanel" aria-labelledby="insights-tab">
            <div class="row">
              <div class="col-lg-12">
                <div class="row in-max-650">
                  <div class="col-6 col-md-3">
                    <!-- Product Modal -->
                    <div class="jbl-modal-link" data-toggle="modal" data-target="#productDescriptionModal">
                      <img class="img-fluid hero-img" :src="require('@/assets/images/ib-product-m.svg')" alt="icon">
                      <p>Product Details</p>
                    </div>
                    <!-- Modal -->
                    <div class="modal fade" id="productDescriptionModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                      <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content">
                          <div class="jbl-m-inner">
                            <div class="modal-header">
                              <h5 class="jbl-m-title" id="productDescriptionModalTitle">Product Detail</h5>
                              <span class="ib-m-close ib-x-icon" data-dismiss="modal" aria-label="Close">
                                <img class="img-fluid" :src="require('@/assets/images/jbl-m-x-icon.png')" alt="Close" />
                              </span>
                            </div>
                            <div class="modal-body">
                              <p class="jbl-m-list">{{selectedProduct.product.description}}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-6 col-md-3" v-if="selectedProduct.things_to_note">
                    <!-- Things To Note Modal -->
                    <div class="jbl-modal-link" data-toggle="modal" data-target="#thingsToNoteModal">
                      <img class="img-fluid hero-img" :src="require('@/assets/images/ib-note-m.svg')" alt="icon">
                      <p>Things To Note</p>
                    </div>
                    <!-- Modal -->
                    <div class="modal fade" id="thingsToNoteModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                      <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content">
                          <div class="jbl-m-inner">
                            <div class="modal-header">
                              <h5 class="jbl-m-title" id="thingsToNoteModalTitle">Things To Note</h5>
                              <span class="ib-m-close ib-x-icon" data-dismiss="modal" aria-label="Close">
                                <img class="img-fluid" :src="require('@/assets/images/jbl-m-x-icon.png')" alt="Close" />
                              </span>
                            </div>
                            <div class="modal-body">
                              <div class="jbl-m-inner">
                                <p class="jbl-m-list" v-html="selectedProduct.things_to_note"></p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-6 col-md-3" v-if="selectedProduct.why_buy">
                    <!-- Why Buy Modal -->
                    <div class="jbl-modal-link" data-toggle="modal" data-target="#whyBuyModal">
                      <img class="img-fluid hero-img" :src="require('@/assets/images/ib-whybuy-m.svg')" alt="icon">
                      <p>Why Buy</p>
                    </div>
                    <!-- Modal -->
                    <div class="modal fade" id="whyBuyModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                      <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content">
                          <div class="jbl-m-inner">
                            <div class="modal-header">
                              <h5 class="jbl-m-title" id="whyBuyModalTitle">Why Buy</h5>
                              <span class="ib-m-close ib-x-icon" data-dismiss="modal" aria-label="Close">
                                <img class="img-fluid" :src="require('@/assets/images/jbl-m-x-icon.png')" alt="Close" />
                              </span>
                            </div>
                            <div class="modal-body">
                              <p class="jbl-m-list" v-html="selectedProduct.why_buy"></p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-6 col-md-3">
                    <!-- Coverages Modal -->
                    <div class="jbl-modal-link" data-toggle="modal" data-target="#coveragesModal">
                      <img class="img-fluid hero-img" :src="require('@/assets/images/ib-coverages-m.svg')" alt="icon">
                      <p>{{ Coverage }}</p>
                    </div>
                    <!-- Modal -->
                    <div class="modal fade" id="coveragesModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                      <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content">
                          <div class="jbl-m-inner">
                            <div class="modal-header">
                              <h5 class="jbl-m-title" id="coveragesModalTitle">{{ Coverage }}</h5>
                              <span class="ib-m-close ib-x-icon" data-dismiss="modal" aria-label="Close">
                                <img class="img-fluid" :src="require('@/assets/images/jbl-m-x-icon.png')" alt="Close" />
                              </span>
                            </div>
                            <div class="modal-body">
                              <div id="accordion">
                                <div class="card" v-for="(cover, index) in selectedProduct.core_covers" :key="index">
                                  <div class="in-accordion-link" :id="'heading'+index">
                                    <a class="jbl-card-header" data-toggle="collapse" :data-target="'#collapse'+index" aria-expanded="false" :aria-controls="'collapse'+index">
                                      <img :src="cover.logo" alt="logo" style="width: 35px; height: 35px; margin-right:15px;">
                                      <div class="in-collapse-text">{{cover.cover}}</div>
                                      <span class="plus-icon">&plus;</span>
                                      <span class="minus-icon">&minus;</span>
                                    </a>
                                  </div>

                                  <div :id="'collapse'+index" class="collapse" :class="index == 0 ? 'show' : ''" :aria-labelledby="'heading'+index" data-parent="#accordion">
                                    <div class="jbl-accordion-body">
                                      <div v-if="cover.description != null">
                                        <p class="jbl-summary-price jbl-m-list in-accordion-desc">Description</p>
                                        <p>{{cover.description}}</p>
                                      </div>
                                      <br v-if="cover.description != null && cover.cover_limit != null">
                                      <div v-if="cover.cover_limit != null">
                                        <p class="jbl-summary-price jbl-m-list in-accordion-desc">{{ CoverLimit }}</p>
                                        <p>{{cover.cover_limit}}</p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="in-accordion-text" v-if="selectedProduct.addon_covers.length > 0">Add-ons</div>
                                <div class="card" v-for="(cover, index) in selectedProduct.addon_covers" :key="index">
                                  <div class="in-accordion-link" :id="'heading1'+index">
                                    <a class="jbl-card-header" data-toggle="collapse" :data-target="'#collapse1'+index" aria-expanded="false" :aria-controls="'collapse1'+index">
                                      <img :src="cover.logo" alt="logo" style="width: 35px; height: 35px; margin-right:15px;">
                                      <div class="in-collapse-text">{{cover.cover}}</div>
                                      <span class="plus-icon">&plus;</span>
                                      <span class="minus-icon">&minus;</span>
                                    </a>
                                  </div>

                                  <div :id="'collapse1'+index" class="collapse" :class="index == 0 ? 'show' : ''" :aria-labelledby="'heading1'+index" data-parent="#accordion">
                                    <div class="jbl-accordion-body">
                                      <div v-if="cover.description != null">
                                        <p class="jbl-summary-price jbl-m-list in-accordion-desc">Description</p>
                                        <p>{{cover.description}}</p>
                                      </div>
                                      <br v-if="cover.description != null && cover.cover_limit != null">
                                      <div v-if="cover.cover_limit != null">
                                        <p class="jbl-summary-price jbl-m-list in-accordion-desc">{{ CoverLimit }}</p>
                                        <p>{{cover.cover_limit}}</p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                <!-- </div>
                <div class="row"> -->
                  <div class="col-6 col-md-3" v-if="selectedProduct.exclusions">
                    <!-- Exclusions Modal -->
                    <div class="jbl-modal-link" data-toggle="modal" data-target="#exclusionsModal">
                      <img class="img-fluid hero-img" :src="require('@/assets/images/ib-exclusion-m.svg')" alt="icon">
                      <p>Exclusions</p>
                    </div>
                    <!-- Modal -->
                    <div class="modal fade" id="exclusionsModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                      <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content">
                          <div class="jbl-m-inner">
                            <div class="modal-header">
                              <h5 class="jbl-m-title" id="exclusionsModalTitle">Exclusions</h5>
                              <span class="ib-m-close ib-x-icon" data-dismiss="modal" aria-label="Close">
                                <img class="img-fluid" :src="require('@/assets/images/jbl-m-x-icon.png')" alt="Close"/>
                              </span>
                            </div>
                            <div class="modal-body">
                              <p class="jbl-m-list" v-if="selectedProduct.exclusions"></p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-6 col-md-3" v-if="selectedProduct.brochure">
                    <a :href="selectedProduct.brochure" target="_blank">
                      <div class="jbl-modal-link">
                        <img class="img-fluid hero-img" :src="require('@/assets/images/ib-brochure-m.svg')" alt="icon">
                        <p>Brochure</p>
                      </div>
                    </a>
                  </div>

                  <div class="col-6 col-md-3" v-if="selectedProduct.claim_example">
                    <!-- Claim Examples Modal -->
                      <a class="jbl-modal-link" :href="selectedProduct.claim_example" target="_blank">
                        <img class="img-fluid hero-img" :src="require('@/assets/images/ib-claim-examples-m.svg')" alt="icon">
                        <p>Policy Wording</p>
                      </a>
                    <!-- Modal -->
                    <div class="modal fade" id="claimExampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                      <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content">
                          <div class="jbl-m-inner">
                            <div class="modal-header">
                              <h5 class="jbl-m-title" id="claimExampleModalTitle">Claim Examples</h5>
                              <span class="ib-m-close ib-x-icon" data-dismiss="modal" aria-label="Close">
                                <img class="img-fluid" :src="require('@/assets/images/jbl-m-x-icon.png')" alt="Close" />
                              </span>
                            </div>
                            <div class="modal-body">
                              <p class="jbl-m-list" v-html="selectedProduct.claim_example"></p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-6 col-md-3" v-if="selectedProduct.glossary">
                    <a :href="selectedProduct.glossary" target="_blank">
                      <div class="jbl-modal-link">
                        <img class="img-fluid hero-img" :src="require('@/assets/images/ib-glossary-m.svg')" alt="icon">
                        <p>Glossary</p>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--Beneficiary Detail-->
          <div class="col-md-12 tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab" v-if="beneficiaries_area">
            <div class="row">
              <!-- pl-xl-0  -->
              <div class="col-xl-12">
                <div class="row claim-sub-heading pl-0 pl-xl-3">
                  <div class="col-12">
                    {{ policy_detail.insurance_sub_type }}
                    <span><small>{{ policy_detail.product.product_name }}</small></span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3" v-if="policy_detail.policy_no != null">
                    <p class="claim-row-data claim-row-sub-heading pl-0 pl-xl-3">Policy No:</p>
                    <p class="claim-row-data pl-0 pl-xl-3">{{ policy_detail.policy_no }}</p>
                  </div>
                  <div class="col-md-3" v-else>
                    <p class="claim-row-data claim-row-sub-heading pl-0 pl-xl-3">Order No:</p>
                    <p class="claim-row-data pl-0 pl-xl-3">{{ policy_detail.tcn_no }}</p>
                  </div>
                  <div class="col-md-3" v-if="policy_detail.policy_no != null">
                    <p class="claim-row-data claim-row-sub-heading">Order Date:</p>
                    <p class="claim-row-data">{{ formatDate(policy_detail.created_at) }}</p>
                  </div>
                  <div class="col-md-3">
                    <p class="claim-row-data claim-row-sub-heading">{{ Insured }} Amount:</p>
                    <p class="claim-row-data">{{ policy_detail.sum_insured_currency }} <span class="jbl-text-primary">{{ priceFormatter(policy_detail.sum_insured) }}</span></p>
                  </div>
                </div>
              </div>
            </div>
            <hr>
            <h2 class="claim-sub-heading">Beneficiary Information</h2>
            <div class="panel-group" id="accordion" role="tablist" aria-multiselectable="true">
              <div class="panel panel-default" v-for="(beneficiary, key) in beneficiaries">
                <div class="panel-heading active" role="tab" id="popularProducts">
                  <div class="collapsible-link">
                    <a role="button" class="d-flex in-beneficiary-addon" data-toggle="collapse" data-parent="#accordion" href="#popularProductsAccordion" aria-expanded="false" aria-controls="popularProductsAccordion">
                      <div class="d-flex in-logo-with-text" style="flex: 1;">
                        <img class="img-fluid" :src="require('@/assets/images/jbl-accordion-img-2x.png')" alt="Image">
                      Beneficiary no.{{ key+1 }}
                      </div>
                      <span class="plus-icon">&plus;</span>
                      <span class="minus-icon">&minus;</span>
                    </a>
                  </div>
                </div>
                <div id="popularProductsAccordion" class="panel-collapse collapse in" role="tabpanel">
                  <div class="card-body jbl-card-inner">
                    <table class="table table-borderless">
                      <tr>
                        <td v-if="beneficiary.first_name != '' && beneficiary.first_name != null">
                          <p class="claim-row-data claim-row-sub-heading">First Name</p>
                          <dd class="claim-row-data">{{ beneficiary.first_name }}</dd>
                        </td>
                        <td v-if="beneficiary.last_name != '' && beneficiary.last_name != null">
                          <p class="claim-row-data claim-row-sub-heading">Last Name</p>
                          <dd class="claim-row-data">{{ beneficiary.last_name }}</dd>
                        </td>
                        <td v-if="beneficiary.cnic != '' && beneficiary.cnic != null">
                          <p class="claim-row-data claim-row-sub-heading">Beneficiary CNIC</p>
                          <dd class="claim-row-data">{{ beneficiary.cnic }}</dd>
                        </td>
                        <td v-if="beneficiary.relation.text != '' && beneficiary.relation.text != null">
                          <p class="claim-row-data claim-row-sub-heading">Relation</p>
                          <dd class="claim-row-data">{{ beneficiary.relation.text }}</dd>
                        </td>
                        <td v-if="beneficiary.percentage != '' && beneficiary.percentage != null">
                          <p class="claim-row-data claim-row-sub-heading">Beneficiary Share</p>
                          <dd class="claim-row-data">{{ beneficiary.percentage }}%</dd>
                        </td>
                      </tr>
                      <tr>
                        <td v-if="beneficiary.mobile_no != '' && beneficiary.mobile_no != null">
                          <p class="claim-row-data claim-row-sub-heading">Mobile Number</p>
                          <dd class="claim-row-data">{{ beneficiary.mobile_no }}</dd>
                        </td>
                        <td v-if="beneficiary.email != '' && beneficiary.email != null">
                          <p class="claim-row-data claim-row-sub-heading">Email</p>
                          <dd class="claim-row-data">{{ beneficiary.email }}</dd>
                        </td>
                        <td v-if="beneficiary.address != '' && beneficiary.address != null">
                          <p class="claim-row-data claim-row-sub-heading">Address</p>
                          <dd class="claim-row-data">{{ beneficiary.address }}</dd>
                        </td>
                        <td v-if="beneficiary.dob != '' && beneficiary.dob != null">
                          <p class="claim-row-data claim-row-sub-heading">Date of Birth</p>
                          <dd class="claim-row-data">{{ formatDate(beneficiary.dob) }}</dd>
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--Family Detail-->
          <div class="col-md-12 tab-pane fade" id="family" role="tabpanel" aria-labelledby="family-tab" v-if="family_area">
            <h2 class="claim-sub-heading">Family Information</h2>
            <div class="panel-group" id="accordion1" role="tablist" aria-multiselectable="true">
              <div class="panel panel-default" v-for="(spouse, key) in family.filter(x => x.relation == 'spouse')">
                <div class="panel-heading active" role="tab" id="popularProducts">
                  <div class="collapsible-link">
                    <a role="button" class="d-flex in-beneficiary-addon" data-toggle="collapse" data-parent="#accordion1" :href="`#spouseAccordian${key}`" aria-expanded="false" aria-controls="spouseAccordian">
                      <div class="d-flex in-logo-with-text" style="flex: 1;">
                        <img class="img-fluid" :src="require('@/assets/images/jbl-accordion-img-2x.png')" alt="Image">
                        Spouse no.{{ key+1 }}
                      </div>
                      <span class="plus-icon">&plus;</span>
                      <span class="minus-icon">&minus;</span>
                    </a>
                  </div>
                </div>
                <div :id="`spouseAccordian${key}`" class="panel-collapse collapse in" role="tabpanel">
                  <div class="card-body jbl-card-inner">
                    <table class="table table-borderless">
                      <tr>
                        <td v-if="spouse.first_name != '' && spouse.first_name != null">
                          <p class="claim-row-data claim-row-sub-heading">First Name</p>
                          <dd class="claim-row-data" style="text-transform: capitalize;">{{ spouse.first_name }}</dd>
                        </td>
                        <td v-if="spouse.last_name != '' && spouse.last_name != null">
                          <p class="claim-row-data claim-row-sub-heading">Last Name</p>
                          <dd class="claim-row-data" style="text-transform: capitalize;">{{ spouse.last_name }}</dd>
                        </td>
                        <td v-if="spouse.gender != '' && spouse.gender != null">
                          <p class="claim-row-data claim-row-sub-heading">Gender</p>
                          <dd class="claim-row-data" style="text-transform: capitalize;">{{ spouse.gender }}</dd>
                        </td>
                        <td v-if="spouse.cnic != '' && spouse.cnic != null">
                          <p class="claim-row-data claim-row-sub-heading">CNIC</p>
                          <dd class="claim-row-data">{{ spouse.cnic }}</dd>
                        </td>
                        <td v-if="spouse.relation != '' && spouse.relation != null">
                          <p class="claim-row-data claim-row-sub-heading">Relation</p>
                          <dd class="claim-row-data" style="text-transform: capitalize;">{{ spouse.relation }}</dd>
                        </td>
                        <td v-if="spouse.dob != '' && spouse.dob != null">
                          <p class="claim-row-data claim-row-sub-heading">DOB</p>
                          <dd class="claim-row-data">{{ formatDate(spouse.dob) }}</dd>
                        </td>
                      </tr>
                      <tr>
                        <td v-if="spouse.passport != '' && spouse.passport != null">
                          <p class="claim-row-data claim-row-sub-heading">Passport</p>
                          <dd class="claim-row-data">{{ spouse.passport }}</dd>
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div class="panel-group" id="accordion2" role="tablist" aria-multiselectable="true">
              <div class="panel panel-default" v-for="(child, key) in family.filter(x => x.relation == 'child')">
                <div class="panel-heading active" role="tab" id="popularProducts">
                  <div class="collapsible-link">
                    <a role="button" class="d-flex in-beneficiary-addon" data-toggle="collapse" data-parent="#accordion2" :href="`#childAccordian${key}`" aria-expanded="false" aria-controls="childAccordian">
                      <div class="d-flex in-logo-with-text" style="flex: 1;">
                        <img class="img-fluid" :src="require('@/assets/images/jbl-accordion-img-2x.png')" alt="Image">
                        Child no.{{ key+1 }}
                      </div>
                      <span class="plus-icon">&plus;</span>
                      <span class="minus-icon">&minus;</span>
                    </a>
                  </div>
                </div>
                <div :id="`childAccordian${key}`" class="panel-collapse collapse in" role="tabpanel">
                  <div class="card-body jbl-card-inner">
                    <table class="table table-borderless">
                      <tr>
                        <td v-if="child.first_name != '' && child.first_name != null">
                          <p class="claim-row-data claim-row-sub-heading">First Name</p>
                          <dd class="claim-row-data" style="text-transform: capitalize;">{{ child.first_name }}</dd>
                        </td>
                        <td v-if="child.last_name != '' && child.last_name != null">
                          <p class="claim-row-data claim-row-sub-heading">Last Name</p>
                          <dd class="claim-row-data" style="text-transform: capitalize;">{{ child.last_name }}</dd>
                        </td>
                        <td v-if="child.gender != '' && child.gender != null">
                          <p class="claim-row-data claim-row-sub-heading">Gender</p>
                          <dd class="claim-row-data" style="text-transform: capitalize;">{{ child.gender }}</dd>
                        </td>
                        <td v-if="child.cnic != '' && child.cnic != null">
                          <p class="claim-row-data claim-row-sub-heading">CNIC</p>
                          <dd class="claim-row-data">{{ child.cnic }}</dd>
                        </td>
                        <td v-if="child.relation != '' && child.relation != null">
                          <p class="claim-row-data claim-row-sub-heading">Relation</p>
                          <dd class="claim-row-data" style="text-transform: capitalize;">{{ child.relation }}</dd>
                        </td>
                        <td v-if="child.dob != '' && child.dob != null">
                          <p class="claim-row-data claim-row-sub-heading">DOB</p>
                          <dd class="claim-row-data">{{ formatDate(child.dob) }}</dd>
                        </td>
                      </tr>
                      <tr>
                        <td v-if="child.passport != '' && child.passport != null">
                          <p class="claim-row-data claim-row-sub-heading">Passport</p>
                          <dd class="claim-row-data">{{ child.passport }}</dd>
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div class="panel-group" id="accordion2" role="tablist" aria-multiselectable="true">
              <div class="panel panel-default" v-for="(spouse, key) in family.filter(x => x.relation == 'parent')">
                <div class="panel-heading active" role="tab" id="popularProducts">
                  <div class="collapsible-link">
                    <a role="button" class="d-flex in-beneficiary-addon" data-toggle="collapse" data-parent="#accordion2" :href="`#spouseAccordian${key}`" aria-expanded="false" aria-controls="parentAccordian">
                      <div class="d-flex in-logo-with-text" style="flex: 1;">
                        <img class="img-fluid" :src="require('@/assets/images/jbl-accordion-img-2x.png')" alt="Image">
                        Parent no.{{ key+1 }}
                      </div>
                      <span class="plus-icon">&plus;</span>
                      <span class="minus-icon">&minus;</span>
                    </a>
                  </div>
                </div>
                <div :id="`spouseAccordian${key}`" class="panel-collapse collapse in" role="tabpanel">
                  <div class="card-body jbl-card-inner">
                    <table class="table table-borderless">
                      <tr>
                        <td v-if="spouse.first_name != '' && spouse.first_name != null">
                          <p class="claim-row-data claim-row-sub-heading">First Name</p>
                          <dd class="claim-row-data" style="text-transform: capitalize;">{{ spouse.first_name }}</dd>
                        </td>
                        <td v-if="spouse.last_name != '' && spouse.last_name != null">
                          <p class="claim-row-data claim-row-sub-heading">Last Name</p>
                          <dd class="claim-row-data" style="text-transform: capitalize;">{{ spouse.last_name }}</dd>
                        </td>
                        <td v-if="spouse.gender != '' && spouse.gender != null">
                          <p class="claim-row-data claim-row-sub-heading">Gender</p>
                          <dd class="claim-row-data" style="text-transform: capitalize;">{{ spouse.gender }}</dd>
                        </td>
                        <td v-if="spouse.cnic != '' && spouse.cnic != null">
                          <p class="claim-row-data claim-row-sub-heading">CNIC</p>
                          <dd class="claim-row-data">{{ spouse.cnic }}</dd>
                        </td>
                        <td v-if="spouse.relation != '' && spouse.relation != null">
                          <p class="claim-row-data claim-row-sub-heading">Relation</p>
                          <dd class="claim-row-data" style="text-transform: capitalize;">{{ spouse.relation }}</dd>
                        </td>
                        <td v-if="spouse.dob != '' && spouse.dob != null">
                          <p class="claim-row-data claim-row-sub-heading">DOB</p>
                          <dd class="claim-row-data">{{ formatDate(spouse.dob) }}</dd>
                        </td>
                      </tr>
                      <tr>
                        <td v-if="spouse.passport != '' && spouse.passport != null">
                          <p class="claim-row-data claim-row-sub-heading">Passport</p>
                          <dd class="claim-row-data">{{ spouse.passport }}</dd>
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="modal show" id="DetailModal">
        <div class="modal-dialog">
          <div class="modal-content">
            <!-- Modal Header -->
            <div class="modal-header">
              <h4 class="modal-title">{{  modal_heading }}</h4>
              <button type="button" class="close" data-dismiss="modal" @click="CloseModal()">&times;</button>
            </div>
            <!-- Modal body -->
            <div class="modal-body">
              {{ modal_detail }}
            </div>
            <!-- Modal footer -->
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal" @click="CloseModal()">Close</button>
            </div>
          </div>
          <PaginationComponent v-if="isShowing" @updatePage="changePage" @updatedData="getName"  :chunkSize="chunkSize" :customer_self_policies_filterd="customer_self_policies_filterd" :isShowing="isShowing"/>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import loading from '@/components/Loading/Loading'
  import PaginationComponent from "../../components/PaginationComponent";

  import moment from "moment";
  import _ from 'lodash';

  export default {
    name: 'ViewPolicy',
    components: {
      loading,
      PaginationComponent
    },
    data() {
      return {
        beneficiaries_area: false,
        family_area: false,
        showLoader: true,
        policy_detail: {},
        risk_detail: {},
        beneficiaries: {},
        family: {},
        insurer_detail: {},
        selectedProduct: {},
        modal_detail: '',
        modal_heading: '',
        sections: {},
        plan_detail: {},
        showProducts: false,
        source: this.$route.params.source,
        customer: 'customer',
        Insured : 'Insured',
        SuInsured : 'Sum Insured',
        NetPremium : 'Net Premium',
        GrossPremium : 'Gross Premium',
        Coverage : 'Coverages',
        FIF: 'FIF',
        CoverLimit : 'Cover Limit',
        stage_1 : [],
        policyRisks : {},
        filterPolicyRisks : {},
        customer_self_policies_filterd:{},
        searchKey: '',
        pageOfItems:{},
        dispalyItems:[],
        currentPage:0,
        name:'',
        isShowing : true,
        chunkSize: 10,
        current_renewal_term :  {},
        installments :  {},
        tenureYear : '',
        allTenure : 0,
        PaidTenure : 0,
        PaidInstallments : 0,
        allInstallments : 0,
      };
    },
    created: function () {
      const self = this;
      self.getPolicy(self.$route.params.id);
      self.riskListing(self.$route.params.id);
    },
    computed: {

      chunked() {
        return _.chunk(this.risk_detail.form_data.stage_1,4);
      },
      date() {
        return moment().format('YYYY-MM-DD');
      }
    },
    methods: {
      payNow: function(action){
        this.$router.push({ name: 'Acquisition', params: { classId: this.policy_detail.class_id ,productId: this.policy_detail.product_id }, query:  { tenureAction : action, policyId: this.policy_detail.id }})
      },
      onChange(e){
        const self =this;
        self.chunkSize = parseInt(e.target.value);
      },
      MethodFire(e){
        console.log(1);
        alert(1);
      },
      donloadPDF: async function () {
        const self = this;
        self.showLoader = true;
        var formData = new FormData();
        formData.append('customer_quotation_id', this.$route.params.id);
        await axios.post('customer/risks_listing/pdf', formData).then(function (resp) {
          self.showLoader = false;

          if (resp.data.code == 200) {
            window.open(resp.data.risks, '_blank');
          } else {
            $toast.error(resp.data.message, { position: 'top-right' });
            return false;
          }
        }).catch(function (error) {
          self.showLoader = false;
          if(error.data.errors != undefined) {
            error.data.errors.forEach(element => {
              $toast.error(element.message, { position: 'top-right' });
            });
          } else {
            $toast.error(error.data.message, { position: 'top-right' });
          }
        });
      },
      ViewRisk: function (risk_id){
        this.$router.push({ name: 'RiskView', params: {id: risk_id, policyId: this.$route.params.id } });
      },
      getName(name){
        this.dispalyItems = name;
      },
      changePage(value){
        this.currentPage = value;
      },
      filterSearch: function () {
        const self = this;

        if (self.searchKey == ''){
          self.filterPolicyRisks = self.policyRisks;
          // self.customer_self_policies_filterd = self.policyRisks

          return false;
        }
        self.filterPolicyRisks = self.policyRisks.filter(x => x.form_data.stage_1.filter(y => y.display == 1 && y.value.toLowerCase().includes(self.searchKey.toLowerCase())).length > 0  || x.id.toString().includes(self.searchKey));
        // self.customer_self_policies_filterd = self.policyRisks.filter(x => x.form_data.stage_1.filter(y => y.display == 1 && y.value.toLowerCase().includes(self.searchKey.toLowerCase())).length > 0  || x.id.toString().includes(self.searchKey));

      },
      replaceString(){
        const self = this;
        self.customer =  'Participant';
        self.Insured = 'Participant';
        self.SuInsured = 'Sum Covered';
        self.NetPremium = 'Net Contribution';
        self.GrossPremium = 'Gross Contribution';
        self.Coverage = 'Benefits';
        self.FIF = 'FTF';
        self.CoverLimit = 'Benefit Limit';
      },
      priceFormatter(price) {
        return new Intl.NumberFormat('en-PK').format(price);
      },
      CloseModal() {
        document.getElementById("DetailModal").removeAttribute("role", "dialog");
        document.getElementById("DetailModal").style.display = 'none';
        document.getElementById("DetailModal").classList.remove("show");
      },

      ViewDetail(key) {
        var self = this;
        if (key == 'product') {
          document.getElementById("DetailModal").setAttribute("role", "dialog");
          document.getElementById("DetailModal").style.display = 'block';
          document.getElementById("DetailModal").classList.add("show");
          self.modal_heading = 'Product';
          self.modal_detail = self.plan_detail.product.description;
        } else if(key == 'things_to_note') {
          document.getElementById("DetailModal").setAttribute("role", "dialog");
          document.getElementById("DetailModal").style.display = 'block';
          document.getElementById("DetailModal").classList.add("show");
          self.modal_heading = 'Things To Note';
          self.modal_detail = self.plan_detail.things_to_note;
        } else if(key == 'why_buy') {
          document.getElementById("DetailModal").setAttribute("role", "dialog");
          document.getElementById("DetailModal").style.display = 'block';
          document.getElementById("DetailModal").classList.add("show");
          self.modal_heading = 'Why Buy';
          self.modal_detail = self.plan_detail.why_buy;
        } else if(key == 'core_covers') {
        } else if(key == 'exclusions') {
          document.getElementById("DetailModal").setAttribute("role", "dialog");
          document.getElementById("DetailModal").style.display = 'block';
          document.getElementById("DetailModal").classList.add("show");
          self.modal_heading = 'Exclusions';
          self.modal_detail = self.plan_detail.exclusions;
        } else if(key == 'brochure') {
          window.open(self.plan_detail.brochure,'_blank');
        } else if(key == 'claim_example') {
          document.getElementById("DetailModal").setAttribute("role", "dialog");
          document.getElementById("DetailModal").style.display = 'block';
          document.getElementById("DetailModal").classList.add("show");
          self.modal_heading = 'Claim Example';
          self.modal_detail = self.plan_detail.claim_example;
        } else if(key == 'glossary_file') {
          window.open(self.plan_detail.glossary_file,'_blank');
        }
      },
      chunkedData(data) {
        return _.chunk(data,4);
      },
      formatDate(date) {
        return moment(date).format('DD-MMM-YYYY');
      },
      formatDynamicDate(date) {
        return moment(date, 'YYYY-MM-DD').format('DD-MMM-YYYY');
      },
      riskListing: async function (id) {
        const self = this;
        self.showLoader = true;
        await axios.get('customer/risks_listing?form_data=1&customer_quotation_id=' + id).then(function (resp) {
          if (resp.data.code == 200) {
            self.policyRisks = resp.data.risks;
            self.filterPolicyRisks = resp.data.risks;
            self.customer_self_policies_filterd = resp.data.risks;
          } else {
            $toast.error(resp.data.message, { position: 'top-right' });
            return false;
          }



        }).catch(function (error) {
          self.showLoader = false;
          if(error.data.errors != undefined) {
            error.data.errors.forEach(element => {
              $toast.error(element.message, { position: 'top-right' });
            });
          } else {
            $toast.error(error.data.message, { position: 'top-right' });
          }
        });
      },
      async getPolicy(id) {
        var self = this;
        self.showLoader = true;
        await axios.get('customer/policy_detail?id=' + id).then(function (resp) {
          if (resp.data.code == 200) {
            self.policy_detail = resp.data.data;
            self.current_renewal_term = self.policy_detail.current_renewal_term;
            self.installments = self.policy_detail.installments ? self.policy_detail.installments : undefined;
            if (self.policy_detail.installments != undefined){
              let installmentKeys = Object.keys(self.policy_detail.installments);
              if (installmentKeys.length > 0){
                for (let i=0; i<installmentKeys.length ;i++){
                  self.PaidInstallments = self.PaidInstallments + self.policy_detail.installments[installmentKeys[i]].filter(x => x.payment_status != 'pending').length;
                  self.allInstallments = self.allInstallments + self.policy_detail.installments[installmentKeys[i]].length;
                }
              }
            }

            let risk_id = resp.data.data.risks[0].id;


            if (self.policy_detail.is_takaful == 1){
              self.replaceString();
            }
            self.BeneficiaryDetail(resp.data.data.id, self.policy_detail.consumer_status);
            self.FamilyDetail(resp.data.data.id);
            self.insurerDetail(resp.data.data.id);
            self.planDetail(self.policy_detail.plan_id);

            axios.get('customer/risk_detail?customer_quotation_id=' + id + '&quotation_risk_id=' +risk_id).then(function (response) {
              if (response.data.code == 200) {
                self.risk_detail = response.data.data;
                self.stage_1 = self.chunkedData(self.risk_detail.form_data.stage_1);
                self.FilterDate(self.risk_detail.form_data.stage_3);

                self.showLoader = false;
              }
            })

          } else {
            $toast.error(resp.data.message, { position: 'top-right' });
            return false;
          }



        }).catch(function (error) {
          self.showLoader = false;
          if(error.data.errors != undefined) {
            error.data.errors.forEach(element => {
              $toast.error(element.message, { position: 'top-right' });
            });
          } else {
            $toast.error(error.data.message, { position: 'top-right' });
          }
        });
      },
      async planDetail(id) {
        var self = this;
        self.showLoader = true;
        await axios.get('plan_detail/' + id + '?customer_quotation_id=' + self.$route.params.id).then(function (resp) {
          self.showLoader = false;
          if (resp.data.code == 200) {
            self.plan_detail = resp.data.data.plan;
            self.selectedProduct = self.plan_detail;
          } else {
            $toast.error(resp.data.message, { position: 'top-right' });
            return false;
          }
        }).catch(function (error) {
          self.showLoader = false;
          if(error.data.errors != undefined) {
            error.data.errors.forEach(element => {
              $toast.error(element.message, { position: 'top-right' });
            });
          } else {
            $toast.error(error.data.message, { position: 'top-right' });
          }
        });
      },
      async BeneficiaryDetail (id, status) {
        var self = this;
        self.$route.params.id
        url = 'customer/policy_beneficiaries?policy_id=' + id;
        if (status === 'inprocess') {
          var url = 'customer/policy_beneficiaries?status=inactive&policy_id=' + id;
        }
        self.showLoader = true;
        await axios.get(url).then(function (resp) {
          self.showLoader = false;
          if (resp.data.code == 200) {
            self.beneficiaries = resp.data.data;
            if (self.beneficiaries.length > 0){
              self.beneficiaries_area = true;
            }
          } else {
            $toast.error(resp.data.message, { position: 'top-right' });
            return false;
          }
        }).catch(function (error) {
          self.showLoader = false;
          if(error.data.errors != undefined) {
            error.data.errors.forEach(element => {
              $toast.error(element.message, { position: 'top-right' });
            });
          } else {
            $toast.error(error.data.message, { position: 'top-right' });
          }
        });
      },
      async FamilyDetail (id) {
        var self = this;
        let url = 'customer/policy_family_members?policy_id=' + id;
        self.showLoader = true;
        await axios.get(url).then(function (resp) {
          self.showLoader = false;
          if (resp.data.code == 200) {
            self.family = resp.data.data;
            if (self.family.length > 0){
              self.family_area = true;
            }
          } else {
            $toast.error(resp.data.message, { position: 'top-right' });
            return false;
          }
        }).catch(function (error) {
          self.showLoader = false;
          if(error.data.errors != undefined) {
            error.data.errors.forEach(element => {
              $toast.error(element.message, { position: 'top-right' });
            });
          } else {
            $toast.error(error.data.message, { position: 'top-right' });
          }
        });
      },
      async insurerDetail(id) {
        var self = this;
        self.$route.params.id;
        self.showLoader = true;
        await axios.get('customer/quotation/customer_details?quotation_id=' + id).then(function (resp) {
          self.showLoader = false;
          if (resp.data.code == 200) {
            self.insurer_detail = resp.data.data;
          } else {
            $toast.error(resp.data.message, { position: 'top-right' });
            return false;
          }
        }).catch(function (error) {
          self.showLoader = false;
          if(error.data.errors != undefined) {
            error.data.errors.forEach(element => {
              $toast.error(element.message, { position: 'top-right' });
            });
          } else {
            $toast.error(error.data.message, { position: 'top-right' });
          }
        });
      },
      FilterDate(data) {
        var self = this;
        let list = {};
        $.each(data, function(key, value) {
          if (list[value.section_name] === undefined ) {
            list[value.section_name] = [];
          }
          list[value.section_name].push(value);
        });
        list = Object.assign({}, list);
        self.sections = list;
      },
      renewPolicy(policy) {
        const self = this;
        if(policy.can_renew_policy) {
          self.$router.push({ name: 'Renew', params: { quotationId: policy.id, subClassId: policy.subclass_id } });
        } else {
          $toast.error('Cannot renew this policy', { position: 'top-right' });
        }
      },
      calculateExpiry(date) {
        var eventdate = moment(date, "YYYY-MM-DD");
        var todaysdate = moment();
        return eventdate.diff(todaysdate, 'days') < 0 ? 0 : eventdate.diff(todaysdate, 'days');
      }
    }
  };
</script>

<style scoped>
  .active {
    display: block !important;
  }
  .tab-pane {
    display: none;
  }
  .claim-doc-icon p {
    font-family: "Avenir Medium";
    font-size: 14px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
    text-align: left;
    color: #4c505d;
    margin-bottom: 0px;
  }
  .claim-data-icon img {
    margin: 0 auto;
  }
  /* .claim-data-icon {
    width: 121px;
    height: 124px;
    border-radius: 10px;
    border: solid 1px #e5e5e5;
    background-color: #ffffff;
    box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.17);
    display: flex !important;
    justify-content: space-evenly;
    align-items: center;
    flex-direction: column;
  } */
  .claim-data-icon img{
    width: 40px;
    margin-top: 8px;
  }
  /* .claim-data-icon:not(:nth-of-type(1)) {
    margin-left: 15px;
    margin-right: 15px;
  } */
  .claim-row-sub-heading {
    font-family: "Avenir Book";
    font-size: 15px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.38;
    letter-spacing: normal;
    text-align: left;
    padding-left: 20px;
    color: #ef7c94;
    color: #ef7c94 !important;
  }
  .jbl-nav-tabs .nav-item .nav-link:hover, .jbl-nav-tabs .nav-item .nav-link:active, .jbl-nav-tabs .nav-item .nav-link:focus,.jbl-nav-tabs .nav-item {
    border: solid 1px transparent;
    color: #fff !important;
    height: 61px;
    border-radius: 31px;
    background-color: #def3f7;
    display: flex !important;
    align-items: center;
    justify-content: center;
  }
  .jbl-nav-tabs .nav-item .nav-link:hover, .jbl-nav-tabs .nav-item .nav-link:active, .jbl-nav-tabs .nav-item .nav-link:focus,.jbl-nav-tabs .nav-item .active {
    border: solid 1px var(--primary-color);
    background-color: var(--primary-color);
    color: #fff !important;
    height: 61px;
    border-radius: 31px;
    display: flex !important;
    align-items: center;
    justify-content: center;
  }
  .jbl-nav-tabs .nav-item .nav-link {
    color: #5b6770;
  }
  .jbl-nav-tabs {
    border-radius: 31px;
    box-shadow: 0 3px 26px 0 rgba(0, 0, 0, 0.08);
    background-color: #def3f7;
    border: 0;
    font-family: "Avenir Medium";
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.29;
    letter-spacing: normal;
    text-align: left;
    color: #5b6770;
    margin: 20px 0 10px 15px;
    /* padding-top: 1px;
    padding-bottom: 1px; */
  }
  table > tbody > tr, .data-row {
    margin: 10px 0;
    padding: 20px 30.7px 20px 15px;
    border-radius: 10px;
    box-shadow: 0 3px 26px 0 rgba(0, 0, 0, 0.08);
    border: solid 1px #dedada;
    background-color: #ffffff;
  }
  .data-row .action-area {
    text-align: right;
  }
  .data-row .action-area i {
    width: 7.9px;
    height: 14.6px;
    color: #5b6770;
  }
  .claim-sub-heading {
    width: 100%;
    min-height: 54px;
    margin: 20px 0px;
    padding: 16px;
    border-radius: 7px;
    /* border: dotted 2px #3d9cbd; */
    border: dashed 2px #3d9cbd;
    background-color: rgba(61, 156, 189, 0.03);
    font-family: "Avenir Heavy";
    font-size: 16px;
    /* font-weight: 900; */
    text-align: left;
    color: #ef7c94 !important;
  }
  .data-row .claim-sub-heading {
    font-family: "Avenir Heavy";
    font-size: 16px;
    /* font-weight: 900; */
    text-align: left;
    color: #ef7c94 !important;
  }
  .data-row .claim-row-sub-desc {
    color: #5b6770;
  }
  .data-row .status-danger {
    background-color: rgba(30, 203, 16, 0.09);
    font-size: 12px;
    font-stretch: normal;
    font-style: normal;
    color: #1ecb10;
    letter-spacing: normal;
  }
  .data-row .status {
    padding: 6px 24px;
    border-radius: 6px;
    font-family: "Avenir Medium";
  }
  .data-row .claim-row-data {
    font-family: "Avenir Medium";
    font-size: 19px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.37;
    letter-spacing: normal;
    text-align: left;
    color: #5b6770;
  }
  .data-row .claim-row-heading {
    font-family: "Avenir Medium";
    font-size: 22px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.32;
    letter-spacing: normal;
    text-align: left;
    color: #5b6770;
  }
  label {
    position: absolute;
    top: 0;
    right: 1px;
    bottom: 1px;
    left: .5em;
    z-index: 1;
    height: 1em;
    font-size: 13px;
    line-height: 3.5em;
    color: #999;
    white-space: nowrap;
    cursor: text;
    transition:all .1s ease;
  }
  .input-placeholder:focus ~ label, .input-placeholder:valid ~label {
    font-size:11px;
    left:10px;
    top:-10px;
  }
  .input-placeholder:valid ~label {
    color:green;
  }
  .input-placeholder:focus:invalid ~label {
    color:red;
  }
  .jbl-data-img{
    width: 100px;
    height: 65px;
    margin-right: .6rem;
  }
  .table.table-borderless td {
    padding: 1rem 0rem;
  }
  @media (max-width:576px) {
    nav.nav-tabs.jbl-nav-tabs{
      margin: 0 auto;
    }
     .jbl-nav-tabs .nav-item .nav-link:hover, .jbl-nav-tabs .nav-item .nav-link:active, .jbl-nav-tabs .nav-item .nav-link:focus,.jbl-nav-tabs .nav-item {
      border: solid 1px transparent;
      height: 2.2rem;
    }

    .jbl-nav-tabs .nav-item .nav-link:hover, .jbl-nav-tabs .nav-item .nav-link:active, .jbl-nav-tabs .nav-item .nav-link:focus,.jbl-nav-tabs .nav-item .active {
      border: solid 1px #007bff;
      height: 2.2rem;
    }
    .jbl-nav-tabs {
      font-size: 14px;
    }
    .nav-item .nav-link{
      padding: 0.5rem .5rem;
    }
  }
  dd.claim-row-data {
    font-family: "Avenir Medium";
    font-size: 19px;
    font-weight: 500;
    text-align: left;
    color: #5b6770;
    padding-left: 20px;
  }
  .col-md-3 p.claim-row-data:nth-of-type(2) {
    font-family: "Avenir Medium";
    font-size: 19px;
    font-weight: 500;
    text-align: left;
    color: #5b6770;
    padding-left: 20px;
  }

  .claim-data-icon img {
    margin: 0 auto;
  }
  .claim-car-icon {
    width: 165.3px;
    height: 122.9px;
    border-radius: 10px;
    border: solid 1px #e5e5e5;
    background-color: #ffffff;
    box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.17);
    display: flex !important;
    justify-content: space-evenly;
    align-items: center;
    flex-direction: column;
    margin: 1rem !important;
    padding-left: 10px !important;
    padding-left: 10px !important;
    overflow: hidden;
  }
  .claim-car-icon img{
    width: 100%;
    height: auto;
    margin-top: 8px;
  }
  .claim-car-icon:not(:nth-of-type(1)) {
    margin-left: 15px;
    margin-right: 15px;
  }
  button:hover, button:focus{
  border: 1px solid transparent !important;
  outline: transparent !important;
  box-shadow: transparent !important;
  text-decoration: none !important;
  }
   .claim-data-icon img {
    margin: 0 auto;
  }
  .data-row p {
    color :#5b6770;
  }
  table > tbody > tr, .data-row {
    margin: 10px 0;
    padding: 20px 30.7px 20px 15px;
    border-radius: 10px;
    border: solid 1px #dedada;
    background-color: #ffffff;
  }
  .data-row .action-area {
    text-align: right;
  }
  .data-row .action-area i {
    width: 7.9px;
    height: 14.6px;
    color: #5b6770;
  }
  .data-row .claim-row-sub-heading {
    color: #a9adaf;
  }
  .data-row .claim-row-sub-desc {
    color: #5b6770;
  }
  .data-row .status-danger {
    background-color: rgba(30, 203, 16, 0.09);
    font-size: 12px;
    font-stretch: normal;
    font-style: normal;
    color: #1ecb10;
    letter-spacing: normal;
  }
  .data-row .status {
    margin: 10px 61.3px 10px 52px;
    padding: 6px 24px;
    border-radius: 6px;
    font-family: "Futura PT";
  }
  .data-row .claim-row-data {
    font-family: "Futura PT";
    font-size: 17px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 8px;
    letter-spacing: normal;
    text-align: left;
  }
  .data-row .claim-row-heading {
    font-family: "Futura PT";
    font-size: 22px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.32;
    letter-spacing: normal;
    text-align: left;
    color: #5b6770;
  }
  .in-listing-img {
    width: 79px;
    height: 66px;
    background-color: #ecf3f5;
    border-radius: 11px;
    border: 1px solid gainsboro;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
  }
  .in-listing-img img{
    width: 100% !important;
    max-width: 70px !important;
    max-height: 60px !important;
    height: auto !important;
  }

  .position-relative-box {
    width: 25px;
    height: 25px;
    border-radius: 50%;
    border: 1px solid gainsboro;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    position: absolute;
    bottom: -10px;
    right: -10px;
  }
  .position-relative-box img{
    width: 100% !important;
    max-width: 23px !important;
    height: auto !important;
  }
  table.claim-listing {
    width: 100%;
    margin: 0 auto;
    font-family: Arial, sans-serif;
    border-collapse: separate;
    border-spacing: 0 10px;
  }
  table.claim-listing td {
    height: 100px !important;
    vertical-align: middle;
    text-align: center;
    position: relative;
  }
  @media (max-width:668px) {
    table.claim-listing td:not(:first-child) {
      height: 60px !important;
    }
    table.claim-listing tbody td:first-child{
      height: auto !important;
    }
  }
  table.claim-listing td:last-child:after {
    content: none;
  }
  table.claim-listing tbody td {
    border-top: 1px solid #eee;
    border-bottom: 1px solid #eee;
    cursor: pointer;
  }
  @media (min-width:669px) {
    table.claim-listing tbody td:first-child {
      border-left: 1px solid #eee;
      border-top-left-radius: 10px;
      border-bottom-left-radius: 10px;
    }
    table.claim-listing tbody td:last-child {
      border-right: 1px solid #eee;
      border-top-right-radius: 10px;
      border-bottom-right-radius: 10px;
    }
    table.claim-listing tbody tr {
      box-shadow: 0 3px 26px 0 rgba(0, 0, 0, 0.08);
    }
  }
  .jbl-table-heading {
    font-family: "Avenir Medium";
    font-weight: 500;
    text-align: left !important;
    font-size: 19px;
    color: #5b6770;
  }

  .jbl-table-heading span {
    font-weight: normal !important;
    font-size: 10px !important;
    font-weight: 500 !important;
    color: #ef7c94 !important;
  }
  .jbl-table-heading small {
    font-weight: normal !important;
    font-size: 11px !important;
    font-weight: 500 !important;
    color: #ef7c94 !important;
  }
  .jbl-date-td {
    font-family: "Avenir Medium";
    font-size: 19px;
    font-weight: 500;
    text-align: left;
    color: #5b6770;
  }
  .jbl-date-heading {
    color: #ef7c94 !important;
    font-family: "Avenir Book";
    font-size: 13px;
    text-align: left;
  }
  table.claim-listing .fa-chevron-right {
    padding-right: 2rem;
    color: #5b6770;
  }
  .jbl-flex-td {
    display: flex;
    flex-direction: column;
  }
  @media (min-width:668px) and (max-width:992px) {
    .jbl-table-heading {
      font-size: 14px;
    }
    .jbl-date-td {
      font-family:"Futura PT Medium";
      font-size: 12px;
    }
    table.claim-listing .fa-chevron-right {
      padding-right: 1rem;
      color: #5b6770;
    }
  }
  .d2c-main-classes {
    background-color: #def3f7;
    border-radius: 31px;
    max-width: fit-content;
    margin: 1px 0 30px;
  }
  .d2c-class-btn {
    display: inline-block;
    margin-bottom: 0;
    text-align: center;
    vertical-align: middle;
    touch-action: manipulation;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    white-space: nowrap;
    padding: 6px 12px;
    border: 1px solid transparent;
    border-radius: 4px;
    height: 61px;
    margin: 0 0 1px;
    border-radius: 31px;
    background-color: #def3f7;
    font-family: "Avenir Medium";
    font-size: 16px;
    font-weight: 500;
    line-height: 1.38;
    color: #4c505d;
    transition: all .3s ease-in;
  }
  @media(max-width:550px){
    .d2c-class-btn{
      padding: 6px 22px !important;
      width: max-content !important;
      font-size: 12px !important;
    }
  }
  .d2c-class-btn:hover {
    background-color: #049cbd;
    color: white;
  }
  .d2c-class-btn:focus, .d2c-class-btn:active, .d2c-class-btn.active {
    outline: none !important;
    background-color: #049cbd;
    color: white;
  }
  .nex-Page-Link .fa-chevron-right {
    color: #aeccd6 !important;
    font-weight: normal !important;
  }
  .d-flex.in-logo-with-text{
  text-transform: capitalize;
}
 .in-jbl-box-heading {
    /* font-family: VarelaRound; */
    font-size: 17px;
    font-weight: normal;
    color: var(--primary-color);
  }

  .in-jbl-table-box {
    border: 2px dashed var(--primary-color)24 !important;
    border-radius: 7px !important;
  }

  table.in-jbl-transaction-table {
    margin: 0px !important;
    background-color: transparent !important;
    width: 100% !important;
    border-collapse: collapse !important;
  }

  table.in-jbl-transaction-table thead tr th {
    background-color: var(--primary-color) !important;
    color: white !important;
  }

  table.in-jbl-transaction-table thead tr th,
  table.in-jbl-transaction-table tbody tr td {
    padding: 20px !important;
    /* border: 1px solid gainsboro !important; */
    text-align: center;
    /* font-family: 'VarelaRound' !important; */
    /* font-weight: 600; */
    vertical-align: middle;
  }

  /* table.in-jbl-transaction-table tbody tr:first-child td:last-child {
    color: #434349 !important;
  } */

  table.in-jbl-transaction-table tbody tr.font-red-bold td a {
    font-size: 14px;
    /* font-family: 'VarelaRound' !important; */
    color: var(--primary-color) !important;
    font-weight: 600 !important;
  }

  table.in-jbl-transaction-table tbody tr.late-transaction td {
    color: #c6c5c5 !important;
  }

  table.in-jbl-transaction-table thead tr:first-child th {
    border-top: 0 !important;
  }

  table.in-jbl-transaction-table tr td:first-child,
  table.in-jbl-transaction-table thead tr:first-child th:first-child {
    border-left: 0 !important;
    border-top-left-radius: 7px !important;
    border-bottom-left-radius: 7px !important;
  }

  table.in-jbl-transaction-table tr:last-child td {
    border-bottom: 0 !important;
  }

  table.in-jbl-transaction-table tr td:last-child,
  table.in-jbl-transaction-table thead tr:first-child th:last-child {
    border-right: 0 !important;
    border-top-right-radius: 7px !important;
    border-bottom-right-radius: 7px !important;
  }
  /* switch button CSS end here */
  .in-jbl-default-flex {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  table.in-jbl-transaction-table thead tr th,
  table.in-jbl-transaction-table thead tr th a {
    letter-spacing: .8px !important;
  }
  table.in-jbl-transaction-table tbody tr.paid td,
  table.in-jbl-transaction-table tbody tr.paid td a {
    font-size: 16px;
    color: var(--primary-color) !important;
    font-weight: 600 !important;
    letter-spacing: .8px !important;
  }
  table.in-jbl-transaction-table tbody tr.pending td,
  table.in-jbl-transaction-table tbody tr.pending td a {
    font-size: 16px;
    color: var(--text-color) !important;
    font-weight: 600 !important;
    letter-spacing: .8px !important;
  }


  table.in-jbl-transaction-table tbody tr.late-transaction td {
    color: #c6c5c5 !important;
  }

  .in-font-red-bold {
    font-size: 14px;
    color: var(--primary-color) !important;
    font-weight: 600 !important;
  }
  .in-flex-relative {
    display: flex;
    position: relative;
    right: 6px;
  }

  /* table row condition base style */
  table.in-jbl-transaction-table tbody tr.pending td div.in-jbl-month {
    color: #d3b512 !important;
  }
  table.in-jbl-transaction-table tbody tr.paid td div.in-jbl-month {
    color: #3fc109 !important;
  }
  .table.in-jbl-transaction-table tbody tr.late td div.in-jbl-month {
    color: var(--primary-color) !important;
  }
  .table.in-jbl-transaction-table tbody tr.late td .in-font-red-bold {
    color: var(--primary-color) !important;
  }
  /* table.in-jbl-transaction-table{
    border-spacing: 0px !important;
    border-collapse: collapse !important;
  } */
  table.in-jbl-transaction-table tr {
    border: 1px solid transparent !important;
    box-shadow: none !important;
  }
  table.in-jbl-transaction-table tr td {
    /* border: 1px solid transparent !important; */
    box-shadow: none !important;
  }
  table.in-jbl-transaction-table thead tr th,
  table.in-jbl-transaction-table tbody tr td
   {
    border: none !important;
    border-left: 1px solid gainsboro !important;
  }
  a[aria-expanded="true"]{
    border-bottom: 1px solid gainsboro;
  }
  .in-long-term-panel-body {
    border-bottom: none !important;
}
.panel-heading a.in-proceed-accordion-a:before {
    content: '\F0D7';
    /* content: '\f078'; */
    font-family: "FontAwesome";
    float: right;
    -webkit-transition: all 0.5s;
    transition: all 0.5s;
    color: #5b6770 !important;
    height: 100%;
    position: absolute;
    right: 0%;
    top: 0%;
    display: flex;
    align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/views/Policy/ViewPolicy.vue